import { lazy } from 'react';

const Maintenance = lazy(() => import(/* webpackChunkName: "maintenance" */ './Maintenance'));

export default Maintenance;
